import mock from './service'
 
export default mock